import React, { ReactComponentElement } from "react";
import { useHistory } from "react-router-dom";

import { Box, Button, Heading, Modal, Stack, Text } from "@seneca/senekit";

import { feedbackSuccessfullySent } from "seneca-common/features/feedback/selectors";
import { useSelectorWithArgs } from "seneca-common/utils/hooks/selectors";

import { ModalPortal } from "features/common/modals/components/ModalNodeContext";
import WithSetModalOpenOnMount from "features/common/modals/components/WithSetModalOpenOnMount";

import FeedbackSuccess from "../FeedbackSuccess";

type Props = {
  feedbackId: string;
  onCloseClick?: () => void;
  closeLink?: string;
  successButtonText?: string;
  children: {
    form: ReactComponentElement<any, any> | ReactComponentElement<any, any>[];
  };
};

export default function FeedbackModal({
  feedbackId,
  onCloseClick,
  closeLink,
  successButtonText = "Back",
  children: { form }
}: Props) {
  const history = useHistory();

  const onModalCloseClick = () =>
    onCloseClick ? onCloseClick() : history.replace(closeLink!);

  const feedbackGiven = useSelectorWithArgs(
    feedbackSuccessfullySent,
    feedbackId
  );

  return (
    <WithSetModalOpenOnMount>
      <ModalPortal>
        <Modal
          fullscreenOnMobile
          onCloseClick={onModalCloseClick}
          modalIsPartOfJourney={false}
        >
          {feedbackGiven ? (
            <Box paddingTop="xxlarge" paddingBottom="xxlarge">
              <Stack align="center" space="xxlarge">
                <FeedbackSuccess speed={1.5} height="300px" width="300px" />
                <Heading level="5">Thanks for your feedback!</Heading>
                <Button onClick={onModalCloseClick} tone="primary">
                  {successButtonText}
                </Button>
              </Stack>
            </Box>
          ) : (
            <Stack align="center" space="xlarge">
              <Heading level="4">Feedback?</Heading>
              <Text align="center">
                Let us know how we can improve Seneca for you! This will help us
                level-up your experience.
              </Text>
              {form}
            </Stack>
          )}
        </Modal>
      </ModalPortal>
    </WithSetModalOpenOnMount>
  );
}
